import React from 'react';
import { ModuleBaseModel, ModuleSectionPropsModel } from '@/types';
import ModuleBase, { IModuleBaseProps } from './ModuleBase';
import SectionHeading from './SectionHeading';

export interface IModuleSectionProps extends IModuleBaseProps<ModuleBaseModel<ModuleSectionPropsModel>> {
  hideSectionHeading?: boolean;
  sectionHeadingProps?: React.HTMLAttributes<HTMLDivElement>;
}

const ModuleSection = ({
  data,
  hideSectionHeading,
  sectionHeadingProps,
  children,
  ...otherProps
}: IModuleSectionProps) => {
  const { props } = data;

  return (
    <ModuleBase data={data} {...otherProps}>
      {!hideSectionHeading && props.heading && props.heading !== '' && (
        <div className="section-heading-container color-from-bg container">
          <SectionHeading data={props} {...sectionHeadingProps} />
        </div>
      )}
      {children}
    </ModuleBase>
  );
};

export default ModuleSection;
